import React from 'react';
import styled from 'styled-components';
import {Grid, Row, Col as UnstyledCol} from 'react-flexbox-grid';

import Screen from '../../components/Screen';
import Content from '../../components/Content';
import ActionCard from '../../components/ActionCard';
import Button from '../../components/Button';
import SubHeader from '../../components/SubHeader';
import CanCreateUser from "../../security/rules/CanCreateUser";

function Welcome({user, onDismiss}) {
  const company = user.company;

  return (
    <Screen title={company.name} activeLink="Dashboard" showTitle={false}>
      <Content>
        <GetStarted>
          <img src="/assets/get-started.svg" alt="" width="290" />
          <SubHeader center>Welcome to your Dashboard</SubHeader>
          <p>Start by creating a form to collect data, adding users, or adding a reminder.</p>
          <SubHeader>Get Started Now</SubHeader>
          <Grid fluid>
            <Row>
              <Col md={12} lg={4}>
                <ActionCard
                  title="Create a Form"
                  description="Create a form to collect data"
                  action={<Button to="/forms">Get Started</Button>}
                />
              </Col>
              {
                (CanCreateUser(user)) && (
                    <Col md={12} lg={4}>
                      <ActionCard
                          title="Add a User"
                          description="Let users access your forms"
                          action={<Button to="/users">Get Started</Button>}
                      />
                    </Col>
                )
              }
              <Col md={12} lg={4}>
                <ActionCard
                  title="Add a Reminder"
                  description="Schedule reminders to finish tasks"
                  action={<Button to="/reminders">Get Started</Button>}
                />
              </Col>
            </Row>
          </Grid>
          <Options>
            <Button tertiary onClick={() => onDismiss(true)}>Don't show this again</Button>
            <Button onClick={() => onDismiss(false)}>Dismiss</Button>
          </Options>
        </GetStarted>
      </Content>
    </Screen>
  );
}


const GetStarted = styled.div`
  margin: 4rem auto 0 auto;
  max-width: 75rem;

  ${SubHeader} {
    @media (max-width: 450px) {
      h2 {
        font-size: 1.4rem;
      }
    }
  }

  img {
    display: block;
    margin: 0 auto 2rem auto;
  }

  > p {
    text-align: center;
    margin: 1rem 0 3rem 0;
    line-height: 1.5;
    color: #747474;
  }
`;

const Col = styled(UnstyledCol)`
  padding: 0.9375rem !important;
`;

const Options = styled.div`
  margin-top: 2rem;
  text-align: right;
  
  ${Button} {
    margin-left: 0.5rem;
  }
`;

export default Welcome;